import { render, staticRenderFns } from "./WelcomeMenu.vue?vue&type=template&id=ef7125f0&scoped=true&"
import script from "./WelcomeMenu.vue?vue&type=script&lang=js&"
export * from "./WelcomeMenu.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeMenu.vue?vue&type=style&index=0&id=ef7125f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7125f0",
  null
  
)

export default component.exports